import { COMMENT_API } from "shared/constants/api-endpoint";
import { ReferenceAndCommentModel } from "shared/models/reference-comment-model";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  CreatedCommentModel,
  CommentModel,
  SearchCommentRequestModel
} from "./comment.models";

export const searchCommentList = async (model: SearchCommentRequestModel) => {
  const createResponse = await apiClient.postHttp<CommentModel[]>(
    `${COMMENT_API}/search_list`,
    model
  );
  return createResponse;
};

export const addComment = async (model: CreatedCommentModel) => {
  const response = await apiClient.postHttp<number>(
    `${COMMENT_API}`,
    model
  );
  return response;
};

export const toggleCommentIsActive = async (commentId: number) => {
  return await apiClient.putHttp(
    `${COMMENT_API}/${commentId}/is_active`
  );
};

export const changeCommentStatus = async (
  commentId: number,
  status: string
) => {
  return await apiClient.putHttp(
    `${COMMENT_API}/${commentId}/status`,
    {
      commentStatus: status,
    },
    // {
    //   headers: {
    //     "content-type": "application/json",
    //   },
    // }
  );
};

export const getReferenceHasNewComment = async (
  commentType: string,
  page: number = 1,
  pageSize: number = 50
) => {
  return await apiClient.getHttp<PagedResult<ReferenceAndCommentModel>>(
    `${COMMENT_API}/reference_has_new_comments?commentType=${commentType}&page=${page}&pageSize=${pageSize}`
  );
};